import { CONTENT_PLATFORM_PROPERTY_NAME, getAssociatedContentTranslations, getContentPropertyValue } from 'content-management-data-lib';
const convertCMPObjectPropertiesToInstanceObjectValues = properties => {
  return Object.keys(properties).reduce((acc, key) => {
    acc[key] = properties[key].rawValue;
    return acc;
  }, {});
};
export const convertCMPObjectToInstanceObject = (cmpObject, contentObjectType) => {
  return {
    type: contentObjectType,
    values: convertCMPObjectPropertiesToInstanceObjectValues(cmpObject.properties),
    translations: getAssociatedContentTranslations(cmpObject).reduce((acc, t) => {
      const language = getContentPropertyValue(t, CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE);
      if (language) {
        acc[language] = {
          values: convertCMPObjectPropertiesToInstanceObjectValues(t.properties),
          type: contentObjectType
        };
      }
      return acc;
    }, {})
  };
};